<div class="dialog-container">
  <div class="dialog-header">
    <h1 mat-dialog-title>{{ data.title }}</h1>
    <button mat-icon-button type="button" aria-label="Stäng dialog" (click)="onCancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>
    <p>{{ data.text }}</p>
  </mat-dialog-content>
  <mat-dialog-actions class="dialog-actions" align="end">
    <button mat-stroked-button color="primary" type="button" (click)="onDiscard()">
      {{ data.discardButton || 'Spara inte' }}
    </button>
    <button mat-raised-button color="primary" class="main-action-button" type="button" (click)="onSave()">
      {{ data.saveButton || 'Spara' }}
    </button>
  </mat-dialog-actions>
</div>